(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-luxury-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.luxury-banner-{{ section.id }}');
    if (!section) return;

    // Intersection Observer for scroll animations
    const animatedElements = section.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      animatedElements.forEach(el => observer.observe(el));
    }

    // RTL arrow mirroring (no Font Awesome dependency)
    if (document.documentElement.dir === 'rtl') {
      const arrows = section.querySelectorAll('.arrow-icon');
      arrows.forEach(arrow => {
        arrow.style.transform = 'scaleX(-1)';
        arrow.style.display = 'inline-block'; // ensure transform works correctly
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
